export function normalizeUaInput(input = '') {
  return input
    .replace(/[’']/g, "'")
    .trim()
    .replace(/\s+/g, ' ')
}

export function transliterateUaToEn(input = '') {
  const value = normalizeUaInput(input)

  if (!value) return ''

  const map = {
    'а': 'a', 'б': 'b', 'в': 'v', 'г': 'h', 'ґ': 'g', 'д': 'd',
    'е': 'e', 'ж': 'zh', 'з': 'z', 'и': 'y', 'і': 'i',
    'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o',
    'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
    'ф': 'f', 'х': 'kh', 'ц': 'ts', 'ч': 'ch',
    'ш': 'sh', 'щ': 'shch', //'в': 'v'
  }

  let result = ''

  for (let i = 0; i < value.length; i++) {
    const char = value[i];
    const lower = char.toLowerCase();
    const prev = value[i - 1];

    const isWordStart = i === 0 || prev === ' ' || prev === '-';

    if (char === ' ' || char === '-') {
      result += char;
      continue
    }

    if (lower === "'" || lower === 'ь') {
      continue
    }

    // правила для особых случаев ю,я,й и всякие такие
    if (lower === 'є') {
      result += isWordStart ? 'ye' : 'ie'
      continue
    }
    if (lower === 'ї') {
      result += isWordStart ? 'yi' : 'i'
      continue
    }
    if (lower === 'й') {
      result += isWordStart ? 'y' : 'i'
      continue
    }
    if (lower === 'ю') {
      result += isWordStart ? 'yu' : 'iu'
      continue
    }
    if (lower === 'я') {
      result += isWordStart ? 'ya' : 'ia'
      continue
    }

    result += map[lower] ?? char;
  }

  return result.replace(/\b\w/g, l => l.toUpperCase());
}
